import { render, staticRenderFns } from "./BoMember.vue?vue&type=template&id=5d727a02&"
import script from "./BoMember.vue?vue&type=script&lang=js&"
export * from "./BoMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports